// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"415db4c4","488":"32b895b7","507":"1788691e","532":"113b237f","769":"383a01e5","801":"152c8eef"}[chunkId] + ".chunk.js";
};